import RequestStatus from '../model/RequestStatus';
import { RecommendationResponse } from '../model/Recommendation';

export const RECOMMENDATION_QUERY_START = 'RECOMMENDATION_QUERY_START';
export const RECOMMENDATION_QUERY_SUCCESS = 'RECOMMENDATION_QUERY_SUCCESS';
export const RECOMMENDATION_QUERY_FAILED = 'RECOMMENDATION_QUERY_FAILED';
export const RECOMMENDATION_REMOVE = 'RECOMMENDATION_REMOVE';

export interface RecommendationQueryStartAction {
  readonly type: string;
  readonly requestStatus: RequestStatus;
  readonly countryCode: string;
  readonly asin?: string;
}

export const setRecommendationQueryStart = (
  countryCode: string,
  asin?: string,
): RecommendationQueryStartAction => ({
  type: RECOMMENDATION_QUERY_START,
  requestStatus: RequestStatus.LOADING,
  countryCode,
  asin,
});

export interface GetRecommendationQueryComplete {
  readonly type: string;
  readonly requestStatus: RequestStatus;
  readonly recommendation: any;
}

export const getRecommendationQuerySuccessAction = (
  response: RecommendationResponse,
): GetRecommendationQueryComplete => ({
  type: RECOMMENDATION_QUERY_SUCCESS,
  requestStatus: RequestStatus.SUCCESS,
  recommendation: response,
});

export const getRecommendationQueryFailedAction =
  (): GetRecommendationQueryComplete => ({
    type: RECOMMENDATION_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    recommendation: null,
  });

export interface RemoveRecommendationAction {
  readonly type: string;
}

export const removeRecommendation = (): RemoveRecommendationAction => ({
  type: RECOMMENDATION_REMOVE,
});
